import Footer from '../components/common/Footer';
import Header from '../components/common/Header';
import AboutUs from '../components/Home/AboutUs';
import ProductAre from '../components/Home/ProductArea';
import HeroSlider from '../components/Home/HeroSlider';
import SEO from '../components/seo';
import AboutArea from "../components/HomeTwo/AboutArea";


const Home = () => {


  return (
    <main>
      <SEO pageTitle="Eagle Vizion" />
      <Header />
      <HeroSlider />
      <AboutUs />
      <ProductAre />
      <div style={{ marginBottom: 'clamp(20px, 4vw, 60px)' }} />
        <AboutArea/>
      

      {/* <EagleVision /> */}
      {/* <ServicesArea /> */}
        {/* <FeatureArea /> */}
            {/* <SDBanner /> */}
      {/* <Testimonial /> */}
      {/* <TeamArea /> */}
      {/* <ProcessArea /> */}
      {/* <BlogArea /> 
      
       <BrandArea />*/}
           

      <Footer />
    </main>
  );
};
export default Home;